@if (hasFilters()) {
  <div class="active-filters-bar">
    <div class="active-filters-bar__chips">
      @for (chip of chips(); track chip.sectionId + chip.value) {
        <span class="active-filters-bar__chip">
          <span class="active-filters-bar__chip-label">{{ chip.label }}</span>
          <button
            class="active-filters-bar__chip-remove"
            type="button"
            [attr.aria-label]="'Eliminar filtro: ' + chip.label"
            (click)="removeFilter.emit({ sectionId: chip.sectionId, value: chip.value })"
          >
            <app-icon [icon]="closeIcon" [size]="12" />
          </button>
        </span>
      }
    </div>

    <app-button variant="ghost" size="sm" (click)="clearAll.emit()">
      Limpiar todos
    </app-button>
  </div>
}
